const PHONE_CHARS = /^\+?[0-9\s().-]+$/

/** A person's phone number: 6-15 digits with optional +, spaces, dashes, dots and brackets (same rule as the API). */
export function isValidPhone(value: string): boolean {
  const v = value.trim()
  if (!v || v.length > 32 || !PHONE_CHARS.test(v)) return false
  const digits = v.replace(/\D/g, '').length
  return digits >= 6 && digits <= 15
}
